module.exports = __webpack_public_path__ + "img/loading.3d0c2b36.gif";